import { ecsClient, getGlobalSessionId } from "@/services";
import { EligibleWithdrawal, BatchWithdrawalItem } from "@/types/adminPayout";

const AdminPayoutServices = {
  getEligibleUsers: async (
    sessionId: string
  ): Promise<EligibleWithdrawal[]> => {
    try {
      const response = await ecsClient.get<EligibleWithdrawal[]>(
        `/payout/eligible-users?sessionId=${sessionId}`
      );
      return response.data;
    } catch (error: any) {
      console.error("❌ Admin payout eligible users fetch error:", {
        error: error,
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
      });
      throw error;
    }
  },

  processBatch: async (withdrawals: BatchWithdrawalItem[]): Promise<void> => {
    const sessionId = getGlobalSessionId();
    if (!sessionId) {
      throw new Error("No session ID available for batch processing");
    }

    try {
      const response = await ecsClient.post("/payout/process-batch", {
        sessionId,
        withdrawals,
      });
      return response.data;
    } catch (error: any) {
      console.error("❌ Admin payout batch process error:", {
        error: error,
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
      });
      throw error;
    }
  },
};

export default AdminPayoutServices;
